<template>
  <w-flex justify-center align-center v-if="$zutil.role('Pentadbir Sistem')">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" style="max-height: 400px;">
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh</th>
          <th class="w-table__header  text-left">Jumlah</th>
          <th class="w-table__header  text-left">Baki</th>
          <th class="w-table__header  text-left" width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.tarikh}}</td>
            <td class="w-table__cell text-left" >{{dt.total}}</td>
            <td class="w-table__cell text-left" >{{dt.baki}}</td>

            <td class="w-table__cell text-left" >
              <w-button dark class="green--bg ml1" @click="addStraw(dt)" v-if="$zutil.role('Pentadbir Sistem') && dt.total < 1">
                 <w-icon class="mr1">fal fa-plus</w-icon> Jana Straw
             </w-button>
             <w-button dark class="green--bg ml1" @click="listStraw(dt)" v-if=" dt.total > 0">
                 <w-icon class="mr1">fal fa-list</w-icon>  Straw
             </w-button>
            </td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>

  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Pengambilan <template v-if="data.jantina == 1">Semen</template><template v-else>Sel Telur</template>
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
      <z-input label="Tarikh *" type="date" v-model="form.tarikh"  :validators="[validators.required]" />
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Simpan</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_straw.show" :fullscreen="dialog_straw.fullscreen" :width="dialog_straw.width" :persistent="dialog_straw.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Jana Straw  <template v-if="data.jantina == 1">Semen</template><template v-else>Sel Telur</template>
    </template>
    <w-form  ref="form_straw"  v-model="dialog_straw.valid" @validate="submitStraw" @success="success" >
      <z-input label="Jumlah *" type="number" v-model="form_straw.total"  :validators="[validators.required]" />
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog_straw.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog_straw.loading" @click="$refs.form_straw.validate()">Jana</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_list.show" :fullscreen="dialog_list.fullscreen" :width="dialog_list.width" :persistent="dialog_list.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-list</w-icon>
       Straw  <template v-if="data.jantina == 1">Semen</template><template v-else>Sel Telur</template>
    </template>
      <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Kod</th>
              <th class="w-table__header  text-left">Status</th>
              <th class="w-table__header  text-left">Tangki</th>
              <th class="w-table__header  text-left">AI Man</th>
            </tr>
          </thead>

          <tbody>
            <template v-if="straws.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in straws">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-left" >{{dt.status}}</td>
                <td class="w-table__cell text-left" >{{dt.tangki}}</td>
                <td class="w-table__cell text-left" >{{dt.user}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog_list.show = false">Tutup</w-button>
      <w-button class="ml1" @click="getTangkiStraw()">Masukan Tangki</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_tangki.show" :fullscreen="dialog_tangki.fullscreen" :width="dialog_tangki.width" :persistent="dialog_tangki.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-list</w-icon>
       Penyimpanan Tangki Straw  <template v-if="data.jantina == 1">Semen</template><template v-else>Sel Telus</template>
    </template>
      <z-select :items="tangki_straw" label="Tangki"  v-model="form_tangki.tangki_id"  />
      <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Kod</th>
              <th class="w-table__header  text-center"><input type="checkbox" v-model="form_tangki.semua" @change="semua()"></th>
            </tr>
          </thead>

          <tbody>
            <template v-if="tangki_straws.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in tangki_straws">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-center" ><input type="checkbox" v-model="dt.pilih"></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog_tangki.show = false">Tutup</w-button>
      <w-button class="ml1" @click="simpanTangkiStraw()">Simpan</w-button>
    </template>
  </w-dialog>
</template>

<script>
export default {
  name: "Pengambilan",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      resourceurl : 'program',
      datas : [],
      straws : [],
      tangki_straws : [],
      tangki_straw : [],
      form : {
        tarikh : ''
      },
      form_tangki : {
        tangki_id : '',
        pengambilan_id : 0,
        semua : false
      },
      form_straw : {
        total : 0
      },
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_straw: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_tangki: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_list: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      }, 
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'baka/pengambilan/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    gettangki(){
      this.$zcomm.get(this.api_service + 'lookup/tangki_straw', {}).then(res => {
        this.tangki_straw = res
      })
    },
    add(){
      this.form.tarikh = ''
      this.dialog.show = true
    },
    addStraw(dt){
      this.form_straw.dari = dt.total ? dt.total : 0
      this.form_straw.baka_pengambilan_id = dt.id
      this.form_straw.tarikh = dt.tarikh
      this.dialog_straw.show = true
    },
    listStraw(dt)
    {
      this.dialog_list.show = true

      this.form_tangki.pengambilan_id = dt
      this.$zcomm.get(this.api_service + 'baka/straw/'+dt.id, {}).then(res => {
        this.straws = res
      })
    },

    getTangkiStraw(){
      this.dialog_tangki.show = true
      this.tangki_straws = [];
      for (var b in this.straws) {
        if(this.straws[b].tangki_id == null){
          this.tangki_straws.push({ 'id' :this.straws[b].id, 'kode' :this.straws[b].kode, 'pilih'  : false})
        }
      }
    },

    semua(){
      for (var b in this.tangki_straws) {
        this.tangki_straws[b].pilih = this.form_tangki.semua
      }
    },

    submit() {
      if(this.form.tarikh){
        this.form.baka_id = this.data.id
        this.form.lkp_baka_id = this.data.lkp_baka_id
        this.form.jenis = this.data.jantina == 1 ? 1 : 2;
        this.form.lkp_ternakan_id = this.data.lkp_ternakan_id
        this.$zcomm.add( 'baka.pengambilan', this.form)
        .then(res => {
          
          this.dialog.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },

    simpanTangkiStraw(){
      if(this.form_tangki.tangki_id){
        var jumlah = 0;
        var baki = 0;
        for (var b in this.tangki_straws) {
          if(this.tangki_straws[b].pilih == true){
            jumlah = jumlah + 1
          }
        }

            
        for (var b in this.tangki_straw) {
          if(parseInt(this.tangki_straw[b].value) == parseInt(this.form_tangki.tangki_id)){
            baki = parseInt(this.tangki_straw[b].baki)
          }
        }
        if(jumlah >= baki){
          alert('Tangki Tidak Mencukupi.. Baki tersedia '+baki);
        }else{
          
          this.form_tangki.tangki_straw = this.tangki_straws;
          this.$zcomm.add( 'baka.straw_tangki', this.form_tangki)
          .then(res => {
            this.dialog_tangki.show = false
            this.listStraw(this.form_tangki.pengambilan_id)
          })
          .finally(() => {
              this.dialog_tangki.show = false

          });
        }
        

      }else{
        alert('Sila Pilih Tangki');
      }
    },

    submitStraw() {
      if(this.form_straw.total > 0){
        this.form_straw.baka_id = this.data.id
        this.form_straw.kode = this.data.kode
        this.form_straw.lkp_baka_id = this.data.lkp_baka_id
        this.form_straw.jenis = this.data.jantina == 1 ? 1 : 2;
        this.form_straw.lkp_ternakan_id = this.data.lkp_ternakan_id
        this.$zcomm.add( 'baka.straw', this.form_straw)
        .then(res => {
          this.dialog_straw.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog_straw.loading = false;

        });
      }
    }
  },
      
  mounted() {
    this.getData()
    this.gettangki()
    
  }
}
      

</script>  
